import Index from '@/front/index/Index'
import Home from '@/front/home/Home'
import Article from '@/front/article/Article'
import OtherArticle from '@/front/article/OtherArticle'
import ArticleList from '@/front/article/ArticleList'
import Honor from '@/front/company/Honor'

export default [{
  path: '/',
  name: Index,
  component: Index,
  redirect: '/home',
  children:[
    {
      path:'home',
      name: Home,
      component: Home
    },
    {
      path:'detail',
      name: Article,
      component: Article
    },{
      path:'details',
      name: OtherArticle,
      component: OtherArticle
    },{
      path: 'list',
      name: 'ArticleList',
      component: ArticleList
    },{
      path:'honor',
      name: 'Honor',
      component: Honor
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/front.js